enum BookingStep {
    ChooseTime = 0,
    Contacts = 1,
    Confirmation = 2
}

const bookingSteps = [
    { title: 'Booking time', description: 'Choose booking time' },
    { title: 'Contacts', description: 'Choose contacts' },
    { title: 'Confirmation', description: 'Confirm booking' },
];

export {
    BookingStep,
    bookingSteps,
};
